<template>
  <div>
    <b-dropdown-item
      v-if="isCurrentApp"
      active
      class="current-app-dropdown-item"
    >
      <img
        class="webtool-icon-dropdown"
        :src="iconSrc"
        alt=""
      />{{ label }}
    </b-dropdown-item>
    <b-dropdown-item
      v-else
      :href="appLink"
      data-app-nav
      class="other-app-dropdown-item"
    >
      <img
        class="webtool-icon-dropdown"
        :src="iconSrc"
        alt=""
      />{{ label }}
    </b-dropdown-item>
  </div>
</template>

<script>
export default {
  name: 'AppDropdownItem',
  props: {
    isCurrentApp: {
      type: Boolean,
      default: false
    },
    iconSrc: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    appLink: {
      type: String,
      default: '#'
    }
  }
}
</script>

<style>
/* Current app styling (white text) */
.current-app-dropdown-item {
  color: white !important;
  background-color: #337ab7 !important;
}

.current-app-dropdown-item:hover,
.current-app-dropdown-item:focus {
  color: white !important;
  background-color: #286090 !important;
}

/* Other apps styling (dark text) */
.other-app-dropdown-item {
  color: #212529 !important;
}

.other-app-dropdown-item .dropdown-item {
  color: #212529 !important;
}

.other-app-dropdown-item:hover,
.other-app-dropdown-item:focus {
  color: #16181b !important;
  background-color: #f8f9fa !important;
}

.other-app-dropdown-item:hover .dropdown-item,
.other-app-dropdown-item:focus .dropdown-item {
  color: #16181b !important;
  background-color: #f8f9fa !important;
}
</style> 